import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function DactylScan() {
    return (
        <main className="relative overflow-hidden bg-gradient-to-b from-slate-900 to-black text-gray-100 pt-24 pb-20">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                {/* -------- Text Section -------- */}
                <div className="flex-1 z-10">
                    <h1 className="text-4xl font-bold text-white">DactylScan Live Scan</h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        DactylScan is our Windows-based Live Scan application designed for HR departments,
                        agencies, and compliance workflows. It supports biometric fingerprint capture,
                        FBI EBTS formatting, and FDLE-compliant transmissions.
                    </p>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Key Features</h2>
                    <ul className="mt-3 list-disc pl-6 text-gray-300 space-y-2">
                        <li>Integration with Futronic & SecuGen SDKs</li>
                        <li>FBI EBTS Type-1/2 packaging</li>
                        <li>FDLE-ready transmission workflow</li>
                        <li>Electronic consent form with signature capture</li>
                        <li>Role-based access with audit logging</li>
                    </ul>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Use Cases</h2>
                    <p className="mt-3 text-gray-300 leading-relaxed">
                        Ideal for HR departments, staffing firms, and government contractors who need to
                        streamline employee onboarding while staying compliant with state and federal
                        identity verification requirements.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>

                {/* -------- Animated Image -------- */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 150 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.1, ease: "easeOut" }}
                >
                    <img
                        src="/Images/fingerprint-scanning.jpg"
                        alt="DactylScan application illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl border border-gray-800"
                    />
                </motion.div>
            </section>
        </main>
    );
}
